import type { AxiosResponse } from 'axios'
import ResponseError from './ResponseError'
export default class ResponseError403 extends ResponseError {
  declare response: AxiosResponse

  constructor(message: string, cause: Error, response: AxiosResponse) {
    super(message, cause, response)

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    // @ts-ignore
    if (Error.captureStackTrace) {
      // @ts-ignore
      Error.captureStackTrace(this, ResponseError403)
    }

    this.name = 'ResponseError403'

    // CustomData
    this.response = response
  }
}
